/*
  NUDIENT: Sidhuvudets dolda meny, paket B2a, M-070 och planen punkt 13.3.

  Ryms inte menyns länkar i Nav/Left lägger assets/nudient-header.css hela menyn
  på en andra rad som inte syns. Det här skriptet märker då menyn med inert, så
  att tabbtangenten och skärmläsaren hoppar över den. Det gäller också när
  menyn är dold med display: none, som i mobilraden. Det ändrar ingenting på
  skärmen, så inget hoppar när sidan laddas. Skriptet räknar om när sidhuvudet
  ändrar storlek, när menyn ändras och när ett typsnitt har laddats, eftersom
  STK Bureau Sans är smalare än reservtypsnittet och kan få menyn att rymmas,
  planen punkt 27.

  Mobilpanelen, paket B2b, M-070 och planen punkt 18. Horizons
  assets/header-drawer.js öppnar och stänger panelen. Det här skriptet:
  - sätter --nudient-drawer-top till radens underkant, så att panelen börjar
    under raden, också när AnnouncementBar syns ovanför,
  - ger menyknappen samma text som Horizons dolda stängknapp i lådan,
    actions.close, medan panelen är öppen, och tillbaka Horizons
    accessibility.menu när den stängs,
  - flyttar fokus till menyknappen när panelen stängs, om fokus låg i panelen
    eller ingenstans, och inte när panelen stängdes av ett tryck i raden. Efter
    bakåt går fokus till raden som öppnade Drilled, planen punkt 18.5,
  - rullar listan till toppen när Drilled öppnas, så att undermenyn börjar
    överst,
  - märker Roots övriga rader med inert medan Drilled är öppen, så att
    skärmläsaren inte når dem bakom undermenyn, och ger bakåtknappen fokus när
    undermenyn har glidit in, eftersom raden som öppnade Drilled då ligger
    under bakåtraden,
  - döljer raden som öppnade Drilled för skärmläsaren med aria-hidden, men
    inte med inert. Horizons fokusfälla i Drilled börjar med den raden och
    måste kunna ge den fokus, annars fastnar Tab på sista länken. Får raden
    fokus, från sista länken med Tab eller från bakåtknappen med Shift+Tab,
    flyttas fokus vidare till bakåtknappen eller sista länken, så att det
    osynliga steget hoppas över. Planen punkt 21,
  - flyttar fokus från X:et till panelens sista synliga rad vid Shift+Tab.
    X:et nås bara i Root, eftersom Horizons fälla i Drilled gäller undermenyn.
    Horizons fokusfälla vill flytta fokus till sitt sista element,
    språkväljaren i den stängda landraden, som inte kan få fokus, och då står
    fokus still. Planen punkt 21,
  - tar bakåtradens titel ur tabbordningen och skärmläsaren när panelen
    öppnas, eftersom raden är bakåtknappen,
  - stänger panelen vid Esc när fokus står på en rad i panelen vars egen
    undermeny är stängd, i praktiken en rad i Root. Horizon stänger då bara
    den redan stängda undermenyn,
  - stänger panelen direkt vid ett tryck på en knapp eller länk i raden utanför
    menyknappen, till exempel sök, konto eller varukorg, och låter knappen
    sedan göra det den gör. Fokusfällan tas bort först, så att sökrutan eller
    varukorgslådan får behålla fokus, och fokus flyttas inte till
    menyknappen. Ett tryck på radens tomma yta gör ingenting. Tillägget till
    M-070 2 oktober 2026, planen punkt 20.

  Megamenyn, paket B2c, M-070 och planen punkt 22. Det här skriptet:
  - pekar om menylänken till mobilskal till phone-cases med vald modell i
    filtret, filter.p.m.attribute.compatible_models, i megamenyns rad och i
    mobilpanelens rad "View all", men först när kunden själv har valt,
    M-007. Ändrat i paket E3, M-013 tillägget punkt 3, som ersätter M-002:s
    vald modells kollektion. Värdet är postens model, och phone-cases byter
    det mot filtrets eget värde, snippets/nudient-model-filter-head.liquid. Adressen byggs av getCasesUrl i @nudient/model-store, M-149. Toppnivån är den som har modellraden, H5 och H6. Bara den första
    modellraden på sidan räknas, och det finns bara en,
  - fäller in väljaren i megamenyns panel när Horizon stänger panelen,
  - märker panelen med data-nudient-panel-scrolls när den rullar, så att
    väljarens meny rullas fram inuti panelen i stället för att hamna under
    fönstrets kant.

  Kontoikonens dolda namn, M-129. Texten LOG IN i raden är borttagen, och
  Shopifys kontoikon, shopify-account, heter själv "Account" i båda lägena.
  Det här skriptet sätter i stället namnet ur
  snippets/nudient-account-name.liquid på ikonens knapp, "Log in" för
  utloggad kund och "Account" för inloggad, på butikens språk. Knappen ligger
  i komponentens egen shadow DOM, och namnet sätts igen om Shopify ritar om
  den eller Horizon ritar om sidhuvudet.

  Värden som inte är tokens:
  - button.account-button: Shopifys knapp i shopify-account.
  - 1: en pixels marginal när menyns läge jämförs med radens höjd.
  - 0 och avrundning till hel pixel: panelens överkant, --nudient-drawer-top,
    följer radens underkant, och är 0 när raden har rullat ut.
  - 0 i scrollTop: Drilled börjar överst.
  - + 1: en pixels marginal när megamenyns panel räknas som rullande.
  - nearest: väljarens meny rullas fram bara så långt som behövs.
*/

import { removeTrapFocus } from '@theme/focus';
import { findModel, getCasesUrl, getModel } from '@nudient/model-store';

const update = () => {
  const header = document.querySelector('#header-component');
  const menu = header?.querySelector('.header__column--left header-menu');
  if (!header || !menu) return;

  const column = menu.parentElement;
  const hidden =
    getComputedStyle(menu).display === 'none' ||
    menu.offsetTop - column.offsetTop >= column.clientHeight - 1;

  if (menu.inert !== hidden) menu.inert = hidden;
};

const start = () => {
  const header = document.querySelector('#header-component');
  if (!header) return;
  update();
  new ResizeObserver(update).observe(header);
  new MutationObserver(update).observe(header, { attributes: true, attributeFilter: ['data-menu-style'] });
  const menu = header.querySelector('header-menu');
  if (menu) new MutationObserver(update).observe(menu, { childList: true, subtree: true, characterData: true });
  document.fonts?.addEventListener('loadingdone', update);
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', start);
} else {
  start();
}

const startDrawer = () => {
  const header = document.querySelector('#header-component');
  if (!header) return;
  const main = () => header.querySelector('#Details-menu-drawer-container');
  let menuLabel = null;
  let leaving = false;

  // Som Horizons reset i assets/header-drawer.js, men utan att vänta på
  // panelens övergång, så att knappen i raden får fokus utan att Horizon tar
  // bort dess fokusfälla efteråt.
  const reset = (details) => {
    details.classList.remove('menu-open');
    details.removeAttribute('open');
    details.querySelector(':scope > summary')?.setAttribute('aria-expanded', 'false');
  };

  // Fokus till menyknappen utan ring efter ett musklick, M-156 tillägget:
  // ringen ska bara synas vid tangentbord. Markeringen tas bort vid nästa
  // tangent och när knappen tappar fokus, assets/nudient-header.css.
  let pointerInput = false;
  document.addEventListener('pointerdown', () => {
    pointerInput = true;
  }, true);
  document.addEventListener('keydown', () => {
    pointerInput = false;
    header.querySelectorAll('[data-nudient-quiet-focus]').forEach((element) => {
      delete element.dataset.nudientQuietFocus;
    });
  }, true);
  const focusButton = (button) => {
    if (pointerInput) {
      button.dataset.nudientQuietFocus = '';
      button.addEventListener('blur', () => delete button.dataset.nudientQuietFocus, { once: true });
    }
    button.focus();
  };

  const place = () => {
    const bottom = Math.max(0, Math.round(header.getBoundingClientRect().bottom));
    header.style.setProperty('--nudient-drawer-top', `${bottom}px`);
  };

  place();
  window.addEventListener('scroll', place, { passive: true });
  window.addEventListener('resize', place);
  header.addEventListener('pointerdown', place, true);
  header.addEventListener('keydown', place, true);

  // Tillfällig rättning av ett fel i Horizons assets/header-drawer.js, M-156,
  // nudient/FEL-hamburgarmeny.md. Klickas menyknappen medan panelen är öppen
  // stänger webbläsaren <details> direkt, mitt i Horizons stängningsanimation.
  // I Chrome blir animationen då inte klar förrän panelen öppnas igen, och
  // Horizons reset stänger panelen mitt i nästa öppning. Här hindras
  // webbläsarens egen stängning, så att Horizon stänger som vid ett klick
  // utanför och tar bort open när animationen är klar. Öppningen ändras inte.
  // Lyssnar på window i fångstfasen, före Horizons lyssnare på document.
  // Prövas och tas bort när Horizon uppdateras, nudient/HORIZON-ANDRINGAR.md.
  window.addEventListener(
    'click',
    (event) => {
      const drawer = main();
      if (!drawer?.open || !(event.target instanceof Element)) return;
      if (event.target.closest('summary') !== drawer.querySelector(':scope > summary')) return;
      event.preventDefault();
    },
    true
  );

  // Horizon stänger den närmaste details vid Esc. På en Root-rad med undermeny
  // är det radens egen undermeny, som redan är stängd, så panelen blev öppen.
  header.addEventListener(
    'keyup',
    (event) => {
      if (event.key !== 'Escape') return;
      const drawer = main();
      if (!drawer?.open || !(event.target instanceof Element)) return;
      const closest = event.target.closest('details');
      if (!closest || closest === drawer || closest.open || !drawer.contains(closest)) return;
      event.stopPropagation();
      drawer.closest('header-drawer')?.close();
    },
    true
  );

  // Ett tryck på en knapp eller länk i raden medan panelen är öppen stänger
  // panelen, och knappen gör sedan det den gör. Horizons knappar lyssnar i
  // bubbelfasen på document. Ett tryck på radens tomma yta gör ingenting.
  header.addEventListener(
    'click',
    (event) => {
      const drawer = main();
      if (!drawer?.open || !(event.target instanceof Element) || drawer.contains(event.target)) return;
      if (!event.target.closest('a[href], button, summary, shopify-account')) return;
      leaving = true;
      removeTrapFocus();
      drawer.querySelector('.menu-drawer')?.classList.remove('menu-drawer--has-submenu-opened');
      drawer.querySelectorAll('details[open]:not(accordion-custom > details)').forEach(reset);
      reset(drawer);
    },
    true
  );

  // Samma urval som Horizons fokusfälla, assets/focus.js
  const focusable =
    "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe";
  const reachable = (element) => {
    const closed = element.parentElement?.closest('details:not([open])');
    if (closed && !(element.localName === 'summary' && element.parentElement === closed)) return false;
    return !element.closest('[inert]') && element.getClientRects().length > 0;
  };

  // Shift+Tab från X:et i Root. Horizon lyssnar på document och har redan
  // försökt flytta fokus till sitt sista element när det här körs.
  header.addEventListener(
    'keydown',
    (event) => {
      if (event.key !== 'Tab' || !event.shiftKey) return;
      const drawer = main();
      if (!drawer?.open || document.activeElement !== drawer.querySelector(':scope > summary')) return;
      const last = [...drawer.querySelectorAll(focusable)].filter(reachable).at(-1);
      if (!last) return;
      event.preventDefault();
      last.focus();
    },
    true
  );

  // Raden som öppnade Drilled ligger under bakåtraden. Horizons fokusfälla ger
  // den fokus när Tab går runt, och Shift+Tab från bakåtknappen når den.
  header.addEventListener(
    'focusin',
    (event) => {
      const summary = event.target;
      if (!(summary instanceof HTMLElement) || summary.localName !== 'summary') return;
      const details = summary.parentElement;
      if (!(details instanceof HTMLDetailsElement) || !details.open || !details.closest('.menu-drawer__navigation')) return;
      const back = details.querySelector('.menu-drawer__back-button');
      const links = [...details.querySelectorAll('.menu-drawer__submenu a[href]')].filter(
        (link) => link.tabIndex >= 0 && link.getClientRects().length > 0
      );
      const next = event.relatedTarget === back ? links.at(-1) : back;
      next?.focus();
    },
    true
  );

  header.addEventListener(
    'toggle',
    (event) => {
      const details = event.target;
      const drawer = main();
      if (!(details instanceof HTMLDetailsElement) || !drawer) return;
      const summary = details.querySelector(':scope > summary');

      if (details === drawer) {
        if (!summary) return;
        if (details.open) {
          place();
          menuLabel ??= summary.getAttribute('aria-label');
          const closeLabel = drawer.querySelector('.menu-drawer__close-button')?.getAttribute('aria-label');
          if (closeLabel) summary.setAttribute('aria-label', closeLabel);
          drawer.querySelectorAll('.menu-drawer__navigation .menu-drawer__title').forEach((title) => {
            title.tabIndex = -1;
            title.setAttribute('aria-hidden', 'true');
          });
        } else {
          if (menuLabel) summary.setAttribute('aria-label', menuLabel);
          if (leaving) {
            leaving = false;
            return;
          }
          const active = document.activeElement;
          if (!active || active === document.body || drawer.contains(active)) focusButton(summary);
        }
        return;
      }

      const navigation = details.closest('.menu-drawer__navigation');
      if (!navigation || !drawer.contains(details)) return;
      const item = details.closest('li');
      const siblings = item?.parentElement ? [...item.parentElement.children] : [];

      if (details.open) {
        navigation.scrollTop = 0;
        siblings.forEach((li) => {
          if (li !== item) li.inert = true;
        });
        if (summary) summary.setAttribute('aria-hidden', 'true');
        const submenu = details.querySelector('.menu-drawer__submenu');
        const back = details.querySelector('.menu-drawer__back-button');
        requestAnimationFrame(() => {
          const moving = submenu ? submenu.getAnimations({ subtree: false }).map((animation) => animation.finished) : [];
          Promise.allSettled(moving).then(() => {
            if (details.open && back && !submenu?.contains(document.activeElement)) back.focus();
          });
        });
      } else {
        siblings.forEach((li) => {
          li.inert = false;
        });
        if (summary) {
          summary.removeAttribute('aria-hidden');
          if (drawer.open) focusButton(summary);
        }
      }
    },
    true
  );
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', startDrawer);
} else {
  startDrawer();
}

const startMegaMenu = () => {
  const row = document.querySelector('[data-nudient-model-link]');
  if (!row) return;
  const handle = row.getAttribute('data-nudient-model-link');
  const picker = row.querySelector('nudient-model-picker');
  const generic = picker?.getAttribute('data-generic-url') || '';
  const item = row.closest('.menu-list__list-item');

  // Länkarna letas upp vid varje byte, eftersom Horizon kan rita om
  // mobilpanelen efter laddningen. Den ursprungliga adressen sparas första
  // gången länken ses och inte är omskriven.
  const links = () =>
    [
      item?.querySelector('.menu-list__link'),
      ...document.querySelectorAll(`a[data-nudient-link-handle="${CSS.escape(handle || '')}"]`),
    ].filter((link) => link instanceof HTMLAnchorElement);

  // Utan anteckning, efter Horizons omritning, är adressen Horizons egen.
  const original = (link) => link.getAttribute('href') || '';

  // Bara ett eget val pekar om länken. Standardmodellen sparas aldrig, M-007.
  const point = () => {
    const model = findModel(getModel());
    links().forEach((link) => {
      if (!link.dataset.nudientOriginalHref) link.dataset.nudientOriginalHref = original(link);
      // M-013 tillägget punkt 3: phone-cases med den valda modellen, M-149.
      const target = model && generic ? getCasesUrl(generic) : link.dataset.nudientOriginalHref;
      if (target && link.getAttribute('href') !== target) link.setAttribute('href', target);
    });
  };

  point();
  document.addEventListener('model:change', point);
  document.addEventListener('toggle', point, true);
  // Horizon ritar om mobilpanelen efter laddningen och skriver då tillbaka
  // länkarnas adresser.
  new MutationObserver(point).observe(document.querySelector('#header-component') || document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['href'],
  });

  // Horizon märker panelen med inert när den stängs.
  const submenu = row.closest('.menu-list__submenu');

  // Ryms panelen i fönstret släpper CSS:en klippningen, och menyn ligger
  // ovanpå sidan under panelen. Rullar panelen, när den är högre än Horizons
  // 80vh, behålls rullningen och menyn rullas fram inuti panelen.
  const inner = submenu?.querySelector('.menu-list__submenu-inner');
  document.addEventListener('nudient-model-picker:open', (event) => {
    if (!submenu || !inner || event.detail !== picker) return;
    const scrolls = inner.scrollHeight > inner.clientHeight + 1;
    submenu.toggleAttribute('data-nudient-panel-scrolls', scrolls);
    if (scrolls) {
      requestAnimationFrame(() => picker.querySelector('.nudient-model-picker__menu')?.scrollIntoView({ block: 'nearest' }));
    }
  });
  if (submenu && picker) {
    new MutationObserver(() => {
      if (submenu.inert && typeof picker.close === 'function') picker.close();
    }).observe(submenu, { attributes: true, attributeFilter: ['inert'] });
  }
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', startMegaMenu);
} else {
  startMegaMenu();
}

const startAccountName = () => {
  const header = document.querySelector('#header-component');
  if (!header) return;
  const watched = new WeakSet();

  const apply = () => {
    const name = header.querySelector('[data-nudient-account-name]')?.getAttribute('data-nudient-account-name');
    if (!name) return;
    header.querySelectorAll('shopify-account').forEach((account) => {
      const root = account.shadowRoot;
      if (!root) return;
      root.querySelectorAll('button.account-button').forEach((button) => {
        if (button.getAttribute('aria-label') !== name) button.setAttribute('aria-label', name);
      });
      if (watched.has(root)) return;
      watched.add(root);
      new MutationObserver(apply).observe(root, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['aria-label'],
      });
    });
  };

  customElements.whenDefined('shopify-account').then(() => requestAnimationFrame(apply));
  new MutationObserver(apply).observe(header, { childList: true, subtree: true });
  apply();
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', startAccountName);
} else {
  startAccountName();
}
